import type {
  LinkedRoleCodeListId,
  SpecificLinkedRoleCodeListId,
} from 'schemaDefinition/types/linkTypes';
import {SpecificLinkedRoleCodeListIds} from 'schemaDefinition/types/linkTypes';

export const isSpecificLinkedRoleCodeListId = (
  codelistId: LinkedRoleCodeListId | undefined,
): codelistId is SpecificLinkedRoleCodeListId => {
  return (
    !!codelistId &&
    SpecificLinkedRoleCodeListIds.includes(
      codelistId as SpecificLinkedRoleCodeListId,
    )
  );
};
